/**
 * The four helplines the client named, in their reading order.
 *
 * TEAM is their acronym — **T**ips, **E**xplanations, the **A**nswer with the
 * standard it is marked against, common **M**istakes — followed by Watch,
 * Practice and the AI tutor. The content behind them is `HelplineBundle`, from
 * `GET /teacher/questions/:id/helplines`, and it is teacher-only.
 */
export const HELPLINE_ORDER = ['TEAM', 'WATCH', 'PRACTICE', 'TUTOR'] as const;
export type HelplineKind = (typeof HELPLINE_ORDER)[number];

export const HELPLINE_LABEL: Record<HelplineKind, string> = {
  TEAM: 'TEAM',
  WATCH: 'Watch',
  PRACTICE: 'Practice',
  TUTOR: 'AI Tutor',
};

/** What each one is, for the column's tooltip and the panel's subtitle. */
export const HELPLINE_BLURB: Record<HelplineKind, string> = {
  TEAM: 'Tips · Explanations · the Answer and its standard · common Mistakes',
  WATCH: 'Short videos on this sub-topic',
  PRACTICE: 'Worksheets, past questions and practice sets — assignable as homework',
  TUTOR: 'Ask the tutor about this sub-topic',
};
